$(document).ready(function () {
    'use strict';

    // reset filter using already existing functionality
    $('.js_resetFilter').on('click', function (e) {
        e.preventDefault();
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
        $('#offerFilter-resetAll').trigger('click');
    });
});